import React, { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux';

import { endSession } from '_store/system/thunks';
import { useRequest, makeRequest, errorMessage, isCustomErrorState } from '_utils/request';

import { LinkButton, Loader, SessionPane } from '_components'

import './Login.sass'

type LogoutError = "401";

const connector = connect(null, ({ endSession }));

const PLogout: React.FC<ConnectedProps<typeof connector>> = ({ endSession }) => {
  const request = makeRequest("/logout", "POST");
  const [result, fetchResult] = useRequest<void, LogoutError>(request, response => (response.status) === 401 ? "401" : null);

  useEffect(() => endSession(), [endSession]);

  return <SessionPane className="login-form">
    <img className="login-form-logo" alt="Sol logo" src="/logo_sol_small.svg" />
    {
      ((result.kind === "success" || isCustomErrorState(result, "401")) && <>
          <p>You were successfully signed out.</p>
          <LinkButton className="btn btn-primary" to="/">Continue</LinkButton>
      </>) ||
      ((result.kind === "error") && <>
        <p>{errorMessage(result.error)}</p>
        <button className="btn btn-primary" onClick={() => fetchResult(request)}>Try again</button>
      </>) ||
      <Loader />
    }
  </SessionPane>
}

export const Logout = connector(PLogout);
